import { MotionFrame } from "../utilities/framer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const ServiceObject = ({
    icon,
    topic,
    textDesc
}) => {
    return (
        <MotionFrame>
            <div className="service glassy-effect">
                <div className="ico gr-bg">
                    <FontAwesomeIcon icon={icon} color="#fff" />
                </div>
                <div className="service-cap">{topic}</div>
                <div className="sm-service-text">{textDesc}</div>
            </div>
        </MotionFrame>
    );
}